import { PaymentDetailsView } from "@portal/BaseComponents/Activites/Payment/PaymentDetailsView/PaymentDetailView";
import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { PaymentFilters } from "@portal/Components/Portal/PotalTabs/Payment/Filters/PaymentFilters";
import { PaymentList } from "@portal/Components/Portal/PotalTabs/Payment/PaymentList";
import { useFormats } from "@portal/hooks/use-formats";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { Provider } from "jotai";
import { useParams } from "react-router-dom";

function PaymentListPage() {
  const { payment_id } = useParams<AppPageParams>();
  const { extra } = useFormats();
  return (
    <>
      <Provider>
        <PaymentFilters />
        <PaymentList extra={extra} />
      </Provider>
      <PaymentDetailsView id={payment_id} open={Boolean(payment_id)} />
      <InvoiceDetailsView />
    </>
  );
}

export { PaymentListPage };
